import {mapMutations, mapState} from "vuex";
import tinycolor from "tinycolor2";

export default {
    methods: {
      ...mapMutations('uiSettings', [
          "setBGComponent",
          "setBGColors",
          "setAnimateBGIfAvailable",
      ])
    },
    computed:{
        ...mapState('uiSettings', {
            bgComponent: state => state.bgComponent,
            bgColors: state => state.bgColors,
            animateBGIfAvailable: state => state.animateBGIfAvailable,
        }),
        shouldAnimateBG(){
            const vm = this
            return vm.$route.meta && vm.$route.meta.animationBG
        },
        bgIsDark(){
            const vm = this
            return vm.isDark

        }
    }
}
